/**
 * Available country codes. These are ordered!
 **/
export const AVAILABLE_LEGAL_COUNTRY_CODES = [
  'FR',
  'DE',
  'ES',
  'AT',
  'BE',
  'NL',
  'PT',
  'IT',
] as const;
export type AvailableLegalCountryCode = (typeof AVAILABLE_LEGAL_COUNTRY_CODES)[number];
